import { ReactNode } from 'react'
import { BoxConstraints, RenderBox } from '../rendering'
import { renderElement } from '../document'

/**
 * ConstrainedBox – identical in spirit to Flutter’s RenderConstrainedBox.
 *
 * `props.constraints` is a full BoxConstraints object (min/max for both axes).
 */
export class ConstrainedRenderBox extends RenderBox<{ constraints: BoxConstraints }> {
  performLayout(parent: BoxConstraints): void {
    const effectiveConstraints = BoxConstraints.enforce(parent, this.props.constraints)

    const child = this.children[0]

    if (child) {
      child.performLayout(effectiveConstraints)

      this.box.width = Math.min(
        Math.max(child.box.width, effectiveConstraints.minWidth),
        effectiveConstraints.maxWidth
      )
      this.box.height = Math.min(
        Math.max(child.box.height, effectiveConstraints.minHeight),
        effectiveConstraints.maxHeight
      )
    } else {
      this.box.width = effectiveConstraints.minWidth
      this.box.height = effectiveConstraints.minHeight
    }

    this.box.x = 0
    this.box.y = 0
  }
}

export function Constrained({
  minWidth = 0,
  maxWidth = Infinity,
  minHeight = 0,
  maxHeight = Infinity,
  children
}: {
  minWidth?: number
  maxWidth?: number
  minHeight?: number
  maxHeight?: number
  children: ReactNode
}) {
  return renderElement(
    new ConstrainedRenderBox({ constraints: { minWidth, maxWidth, minHeight, maxHeight } }),
    children
  )
}
